import React from 'react';

import { TableOfContentsLoader } from '@confluence/table-of-contents/entry-points/TableOfContentsLoader.ts';

export const TableOfContentsHandler = ({
	macroDefaultProps,
	adf,
	cloudId,
	userId,
}: {
	macroDefaultProps: any;
	adf: any;
	cloudId: any;
	userId: any;
}): React.JSX.Element => {
	return (
		<TableOfContentsLoader
			userId={userId}
			cloudId={cloudId}
			adf={adf}
			macroDefaultProps={macroDefaultProps}
		/>
	);
};
